var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_12141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 4.67188C15.5114 5.00405 16.6621 5.66508 17.5844 6.58744C18.5068 7.50981 19.1678 8.66046 19.5 9.92188",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.67188C15.0488 8.08625 16.0856 9.12312 16.5 10.6719",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6616 14.5471C14.7654 14.478 14.8849 14.4359 15.0091 14.4246C15.1334 14.4133 15.2585 14.4332 15.3731 14.4824L19.7944 16.4634C19.9434 16.527 20.0677 16.6373 20.1489 16.7775C20.23 16.9178 20.2635 17.0806 20.2444 17.2415C20.0987 18.33 19.5627 19.3285 18.736 20.0514C17.9093 20.7743 16.8482 21.1723 15.75 21.1715C12.3685 21.1715 9.12548 19.8282 6.73439 17.4371C4.3433 15.046 3 11.803 3 8.42149C2.99916 7.3233 3.3972 6.26219 4.12009 5.43549C4.84298 4.60878 5.84152 4.07276 6.93 3.92711C7.09091 3.908 7.25368 3.94151 7.39395 4.02263C7.53422 4.10375 7.64444 4.22811 7.70813 4.37711L9.68906 8.80211C9.73774 8.91577 9.75756 9.03969 9.74676 9.16285C9.73596 9.28601 9.69489 9.4046 9.62719 9.50805L7.62375 11.8902C7.55269 11.9975 7.51066 12.1213 7.50179 12.2497C7.49291 12.378 7.51749 12.5064 7.57313 12.6224C8.34844 14.2096 9.98906 15.8306 11.5809 16.5984C11.6975 16.6538 11.8266 16.6778 11.9553 16.6681C12.084 16.6584 12.208 16.6153 12.315 16.5431L14.6616 14.5471Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_12141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.171875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.46aa38966b21f60697bdf5dd41910107.svg";
export { ForwardRef as ReactComponent };